import { getJWTToken } from '../../utils/auth';
import { authHeaders } from '../../core/impersonation';

const apiUrl = import.meta.env.REACT_APP_BAMBOO_API_URL ?? '';

// licenses is null for a site-licensed district, which has no seat count.
export interface LicenseRostering {
  licenses: number | null;
  rostered: number;
}

// Null when the district has nothing to show: no record yet, or its schools
// bought their own licenses and the district holds no count of its own.
export async function fetchLicenseRostering(): Promise<LicenseRostering | null> {
  const token = await getJWTToken();
  const response = await fetch(`${apiUrl}/licenses`, { headers: authHeaders(token) });
  if (!response.ok) {
    throw new Error(`licenses fetch failed: ${response.status}`);
  }
  const body = (await response.json()) as Record<string, unknown> | null;
  switch (body?.purchase) {
    case 'none':
    case 'school':
      return null;
    case 'district':
      if (typeof body.licenses !== 'number' || typeof body.rostered !== 'number') {
        throw new Error('licenses response is missing a count');
      }
      return { licenses: body.licenses, rostered: body.rostered };
    case 'site':
      if (typeof body.rostered !== 'number') {
        throw new Error('licenses response is missing a count');
      }
      return { licenses: null, rostered: body.rostered };
    default:
      throw new Error('licenses response has an unknown purchase kind');
  }
}
